import axios from "axios";
import { setCoins } from "../redux/actions/coinsAction";

// Thunk function to fetch crypto coins from the CoinGecko API
const fetchCoins = () => {
  // The actual thunk function that will be executed when dispatched
  return (dispatch) => {
    axios
      .get(
        "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=100&page=1&sparkline=false"
      )
      .then((res) => {
        // Handle the successful response from the API
        let starredCoins = localStorage.getItem("starred_coins");

        if (starredCoins) {
          starredCoins = JSON.parse(starredCoins);
        } else {
          starredCoins = [];
        }

        // Update the coins array by marking starred/unstarred based on local storage
        let data = res.data.map((elem) => {
          if (starredCoins.includes(elem.id)) {
            elem['starred'] = true;
          } else {
            elem['starred'] = false;
          }
          return elem;
        });

        // Dispatch the setCoins action with the updated data
        dispatch(setCoins(data));
      })
      .catch((err) => {
        // Handle errors if the API request fails
        console.log("Error fetching coins:", err);
        dispatch(setCoins([]));
      });
  };
};

// Export the fetchCoins function
export { fetchCoins };
